<p-confirmDialog key="report" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid 2 Col-->
<div class="Grid2Col">
	<!--Application items-->
	<div class="Submenu">
		<h5>Report Items:</h5>

		<p-treeTable
			[value]="TreeItems"
			[loading]="loading"
			[columns]="cols"
			selectionMode="single"
			[(selection)]="SelectedAppItem"
			dataKey="ApplicationItemName"
			(onNodeSelect)="nodeSelect($event)"
			(onNodeUnselect)="nodeUnselect($event)"
			[scrollable]="true"
			scrollHeight="flex"
		>
			<ng-template pTemplate="header">
				<tr>
					<th>Name</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
				<tr [ttSelectableRow]="rowNode">
					<td>
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						{{ rowData.ApplicationItemName }}
					</td>
				</tr>
			</ng-template>
		</p-treeTable>
	</div>

	<!--Modules Access Rights-->
	<div class="Submenu">
		<h5>Reports Access Rights:</h5>

		<!--Checkbox grid-->
		<div class="SubGrid2Col">
			<input
				(ngModelChange)="onAccessChange($event)"
				[(ngModel)]="CurrentAccess"
				[disabled]="DisableCheck()"
				id="CurrentAccess"
				class="form-control CheckBoxStyle"
				type="checkbox"
			/>
			<label for="CurrentAccess">Access</label>
		</div>
	</div>
</div>
